"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketingHubApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var TicketingHubApi = /** @class */ (function (_super) {
    __extends(TicketingHubApi, _super);
    function TicketingHubApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TicketingHubApi.prototype.ticketingHubBlobsCreateBlobDownloadSasUrlsPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerCreateBlobDownloadSasUrlsRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerCreateBlobDownloadSasUrlsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Blobs/CreateBlobDownloadSasUrls',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerCreateBlobDownloadSasUrlsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubBlobsCreateBlobUploadSasUrlsPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerCreateBlobUploadSasUrlsRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerCreateBlobUploadSasUrlsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Blobs/CreateBlobUploadSasUrls',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerCreateBlobUploadSasUrlsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubBlobsDeleteBlobsPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteBlobsRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteBlobsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Blobs/DeleteBlobs',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteBlobsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketCompanyConfigsGetTicketCompanyConfigPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/TicketingHub/TicketCompanyConfigs/GetTicketCompanyConfig',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketPrioritiesGetTicketPrioritiesPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/TicketingHub/TicketPriorities/GetTicketPriorities',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketStatusesGetTicketStatusesPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/TicketingHub/TicketStatuses/GetTicketStatuses',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketTypesGetTicketTypesPost = function (opts) {
        var headers = {};
        return this.request({
            url: '/TicketingHub/TicketTypes/GetTicketTypes',
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsCreateTicketPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerCreateTicketRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerCreateTicketRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/CreateTicket',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerCreateTicketRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsDeleteTicketPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteTicketRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteTicketRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/DeleteTicket',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteTicketRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsDeleteTicketsPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteTicketsRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteTicketsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/DeleteTickets',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerDeleteTicketsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsGetTicketCountPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketCountRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketCountRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/GetTicketCount',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketCountRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsGetTicketIdsPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketIdsRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketIdsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/GetTicketIds',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketIdsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsGetTicketPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/GetTicket',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsGetTicketsPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketsRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketsRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/GetTickets',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerGetTicketsRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    TicketingHubApi.prototype.ticketingHubTicketsUpdateTicketPost = function (_a, opts) {
        var travisBackendControllersTicketingHubControllersTicketingHubControllerUpdateTicketRequest = _a.travisBackendControllersTicketingHubControllersTicketingHubControllerUpdateTicketRequest;
        var headers = {
            'Content-Type': 'application/json',
        };
        return this.request({
            url: '/TicketingHub/Tickets/UpdateTicket',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersTicketingHubControllersTicketingHubControllerUpdateTicketRequest,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return TicketingHubApi;
}(runtime_1.BaseAPI));
exports.TicketingHubApi = TicketingHubApi;
